// Company facts as published in the Impressum. Update here when they change.
export const KONFETTI_COMPANY = {
  name: 'konfetti',
  alternateName: 'gokonfetti',
  legalName: 'Konfetti GmbH',
  url: 'https://gokonfetti.com/',
  logoUrl: 'https://gokonfetti.com/logos/full-logo-color-black.svg',
  email: 'hallo@gokonfetti.com',
  telephone: '+4930257706800',
  address: {
    streetAddress: 'Heidestr. 50',
    postalCode: '10557',
    addressLocality: 'Berlin',
    addressCountry: 'DE',
  },
  vatId: 'DE344165820',
  commercialRegister: 'HRB 229242 B, Amtsgericht Charlottenburg',
  languages: ['German', 'English'],
  socialProfiles: [
    'https://www.linkedin.com/company/gokonfetti/',
    'https://www.facebook.com/gokonfetti/',
    'https://www.instagram.com/gokonfetti/',
    'https://www.pinterest.de/gokonfetti/',
  ],
} as const
